module.exports = __webpack_public_path__ + "img/zs3.187ff7fb.png";